import { useContainer } from '../../useContainer';
import { ToastStateHandler, UserApi } from '../../../api';
import { useTranslation } from '../../useTranslation';
import { PatchDocumentDto, UserDocumentDto } from '../../../commonTypes/user.types';

const useHttpPatchDocument = () => {
    const { t } = useTranslation('newNotifications');
    const userApi: UserApi = useContainer(UserApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const updateDocument = (userSub: string, documentId: string, body: PatchDocumentDto, onUpdated: (doc: UserDocumentDto) => void) => {
        const { exec, abort } = userApi.editUserDocument({
            params: { userSub },
            query: { documentId },
            body: body,
            onSuccess: res => {
                toastHandler.push('success', t('userDocuments.editTitle'), t('userDocuments.editSuccess'));
                onUpdated(res.body);
            },
            onError: () => toastHandler.push('error', t('userDocuments.editTitle'), t('userDocuments.editError')),
        });
        exec();
        return abort;
    };

    return {
        updateDocument,
    };
};

export default useHttpPatchDocument;
